import React, { useEffect } from 'react';
import { Grid, TextField } from '@material-ui/core';

function PalletCountForm({ formData, item, setFormField }) {
    useEffect(() => {
        const palletCountsTmp = [];
        let i = 0;
        while (i < Number(formData.numPallets)) {
            palletCountsTmp.push(formData.palletCounts[i] || '');
            i++;
        }

        if (palletCountsTmp.length > 0 && palletCountsTmp.length != formData.palletCounts.length) {
            setFormField(palletCountsTmp);
        }
    }, [formData]);

    const getPalletName = (ind) => {
        const firstLetterInd = Math.floor(ind / 26);
        const firstLetter = String.fromCharCode('A'.charCodeAt() + firstLetterInd);
        const secondLetterInd = ind - 26 * firstLetterInd;
        const secondLetter = String.fromCharCode('A'.charCodeAt() + secondLetterInd);
        return `${firstLetter}${secondLetter}`;
    };

    return (
        <>
            <h4>Pallet Counts</h4>
            {formData.palletCounts.map((formField, formFieldIndex) => (
                <Grid item xs={12} key={formFieldIndex}>
                    <TextField
                        type="number"
                        style={{ width: '100%', padding: 15 }}
                        label={`Pallet ${getPalletName(formFieldIndex)}`}
                        value={formData.palletCounts[formFieldIndex] || ''}
                        onChange={(event) => {
                            const palletFormDataTmp = JSON.parse(JSON.stringify(formData.palletCounts));
                            palletFormDataTmp[formFieldIndex] = event.target.value;
                            setFormField(palletFormDataTmp);
                        }}
                        onKeyPress={(event) => {
                            if ((event.charCode >= 48 && event.charCode <= 57) === false) {
                                event.preventDefault();
                                return false;
                            }
                        }}
                    />
                </Grid>
            ))}
        </>
    );
}

export { PalletCountForm };
